import {useMemo} from 'react';
import {Stack, Typography} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useSnackbar} from 'notistack';
import {useOnce, useQueryParam} from './react_hooks.js';
import api from './api.js';
import {useLoader} from '../components/Loader.js';
import {openLoginModal} from '../components/Login.js';

export const EmailVerificationProvider = props=>{
    let {children} = props;
    let {enqueueSnackbar} = useSnackbar();
    let [emailVerification, setEmailVerification] = useQueryParam('emailVerification');
    let [userId, token] = useMemo(()=>emailVerification?.split('-')||[], [emailVerification]);
    let [startLoading] = useLoader();
    useOnce(async ()=>{
        let stopLoading;
        try {
            stopLoading = startLoading('מאמת כתובת מייל...');
            await api.verifyEmail({userId, token});
            openLoginModal({note: <Stack direction="row" gap={1} alignItems="center">
              <CheckCircleIcon sx={{color: 'status.success'}}/>
              <Typography variant="body2" fontStyle="italic">
                כתובת המייל אושרה, כעת ניתן להתחבר
              </Typography>
            </Stack>})
        } catch (e) {
            let msg = e.code=='invalid_token' ? e.message : 'אירעה שגיאה, נסו שוב מאוחר יותר';
            enqueueSnackbar(msg, {variant: 'error'});
        } finally {
            setEmailVerification(null);
            stopLoading();
        }
    }, !!(userId&&token&&startLoading));
    return children;
};